<template>
  <div class="animate__animated animate__fadeIn">
    <studyHeader :path="'/afterBooks?type=' + $route.query.type + '&bbid=' + $route.query.bbid + '&lxid=' + $route.query.lxid" />
    <div class="units">
      <div class="main">
        <div class="unitsTitle">
          <img src="../../../assets/images/student/unitsTitle.png" alt="" width="100%">
          <div class="text">选择学习关卡</div>
        </div>
        <el-carousel arrow="never" :interval="60000">
          <el-carousel-item v-for="(data, index) in list" :key="index">
            <div class="images animate__animated animate__flipInY" :style="'animation-delay:' + (indexItem*0.1 + 0.1) + 's'" v-for="(item, indexItem) in data" :key="'id_'+item.id">
              <div class="image" @click="link(item)" :id="item.id">
                <!-- 学习过 -->
                <img class="rain" src="../../../assets/images/student/unlock.png" alt="" v-if="item.lock">
                <!-- 未学习过 -->
                <img class="rain" src="../../../assets/images/student/nounlock.png" alt="" v-else>
                <span>{{item.mc.replace(/\s/g, '').toLowerCase()}}</span>
                <!-- 得过星 -->
                <div class="starses">
                  <div v-for="ele in 3" :key="ele">
                    <img src="../../../assets/images/student/yellowstars.png" v-if="(ele === 1 && item.xj) || (ele === 2 && item.xj>1) || (ele === 3 && item.xj === 3)" alt="">
                    <img src="../../../assets/images/student/whitestars.png" v-else alt="">
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import studyHeader from "@/components/student/studyHeader";
import { getLastUnit } from '@/api/student'
export default {
  components: {
    studyHeader,
  },
  data() {
    return {
      flag: true,
      list: [],
    }
  },
  methods: {
    getAfterJxInfo() {
      try {
        return JSON.parse(sessionStorage.getItem('afterJxInfo') || '{}')
      } catch (e) {
        return {}
      }
    },
    link(data){
      const element = document.getElementById(data.id)
      if (!data.lock) {
        this.$message.warning('暂未开启')
        element.classList.add('animate__animated', 'animate__headShake')
        setTimeout(() => {
          element.className = 'image'
        }, 500)
      } else if (data.xj === 3) {
        this.$message.warning('该单元已完成')
        element.classList.add('animate__animated', 'animate__headShake')
        setTimeout(() => {
          element.className = 'image'
        }, 500)
      } else {
        element.classList.add('animate__animated', 'animate__bounceOut')
        setTimeout(() => {
          let afterJxInfo = this.getAfterJxInfo()
          afterJxInfo.dymc = data.mc
          sessionStorage.setItem('afterJxInfo', JSON.stringify(afterJxInfo))
          this.$router.replace({ name: 'afterWordcontent', query: { type: this.$route.query.type, bbid: this.$route.query.bbid, zid: this.$route.query.zid, zmc: this.$route.query.zmc, dyid: data.id, source: 'studyway',lxid:this.$route.query.lxid } })
        }, 500)
      }
    }
  },
  created() {
    getLastUnit({ jxid: this.getAfterJxInfo().jxid || this.$store.state.userInfo.jxid, xsid: this.$store.state.userInfo.yhid, zid: this.$route.query.zid }).then(res => {
      if (res.success) {
        if (res.result.length) {
          let arr = []
          let lock = true
          res.result.forEach((ele, index) => {
            // 锁单元
            ele.lock = Boolean(ele.xj || !ele.xj && lock)
            if (!ele.xj && lock) {
              lock = false
            }
            // 分组
            if (!arr[parseInt(index / 8)]) {
              arr[parseInt(index / 8)] = []
            }
            arr[parseInt(index / 8)].push(ele)
          })
          this.list = arr
        }
      } else {
        this.$message.error(res.resultDesc)
      }
    })
  },
  mounted(){
  }
}
</script>
<style lang="scss" scoped>
.units {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url('../../../assets/images/student/unitsBanner.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .main {
    background-image: url('../../../assets/images/student/unitBg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    width: 70%;
    height: 70%;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
    padding: 5vw 5vw 0 5vw;
    padding-bottom: 2vw;

    .unitsTitle {
      width: 50%;
      display: inline-block;
      position: absolute;
      top: -10%;
      left: 50%;
      transform: translateX(-50%);

      .text {
        position: absolute;
        top: 0;
        width: 100%;
        text-align: center;
        color: #000;
        font-size: 1.7vw;
        padding-top: 0.5vw;
      }
    }

    .el-carousel__item.is-animating {
      // display: flex;
      // display: -webkit-flex;
      // // justify-content: space-between;
      // flex-direction: row;
      // flex-wrap: wrap;
      .images {
        width: 25%;
        height: 45%;
        float: left;

        .image {
          width: 88%;
          height: 65%;
          margin: auto;
          position: relative;
          cursor: pointer;

          .rain {
            display: block;
            width: 100%;
            height: 100%;
          }

          span {
            display: block;
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: clamp(1rem, 1.4vw, 1.5rem);
            font-family: PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 19px;
            white-space: nowrap;
            -webkit-text-stroke: clamp(1px, 0.12vw, 1.5px) #3193B5;
          }

          .starses {
            position: absolute;
            bottom: -13px;
            left: 16%;
            width: 75%;

            div {
              display: inline-block;
              width: 30%;
              height: 100%;
            }

            img {
              display: inline-block;
              width: 100%;
              // height: 100%;
            }
          }
        }
      }
    }
  }

  .lowerleft {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 24vw;
    height: 12vw;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .lowerright {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 28vw;
    height: 13vw;
    z-index: 2001;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

}
/* ========== 平板端适配样式（去掉背景图） ========== */
@media screen and (min-width: 700px) and (max-width: 1366px) {
  .units {
    .main {
      background-image: none;
    }
  }
}

/* ========== 平板端单元名称优化 (768-1280px) ========== */
@media screen and (min-width: 768px) and (max-width: 1280px) {
  .units {
    .el-carousel__item.is-animating {
      .images {
        .image {
          span {
            font-size: 26px;
            font-weight: 700;
            color: #FFFFFF;
            text-shadow: 0 2px 4px rgba(20, 70, 95, 0.55);
          }
        }
      }
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 700px) {
  .units {
    .main {
      width: 90%;
      height: 80%;
      padding: 8vw 3vw 3vw 3vw;
      background-image: none;
      .unitsTitle {
        width: 80%;
        top: -6%;

        .text {
          font-size: 14px;
          padding-top: 8px;
        }
      }

      .el-carousel__item.is-animating {
        .images {
          width: 33.33%;
          height: auto;
          margin-bottom: 15px;

          .image {
            width: 90%;
            margin: 0 auto;

            span {
              font-size: 22px;
              top: 38%;
              -webkit-text-stroke: 1px #3193B5;
              white-space: nowrap;
            }

            .starses {
              bottom: -8px;
              text-align: center;
              padding-right: 5px;
              div {
                width: 28%;
              }

              img {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .units {
    .main {
      width: 95%;
      height: 85%;
      padding: 10vw 2vw 2vw 2vw;
      background-image: none;
      .unitsTitle {
        width: 90%;
        top: -4%;

        .text {
          font-size: 12px;
          padding-top: 6px;
        }
      }

      .el-carousel__item.is-animating {
        .images {
          width: 50%;

          .image {
            span {
              font-size: 26px;
              -webkit-text-stroke: 0.5px #3193B5;
            }

            .starses {
              bottom: -6px;
              text-align: center;
              padding-right: 5px;
              div {
                width: 26%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.units {
  .el-carousel {
    height: 100%;
    // background: red;
    // 容器
    .el-carousel__container {
      height: 100%;
    }

    // 轮播切换分页器
    .el-carousel__indicators {
      // position: absolute;
      bottom: 0.5vw;
    }
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel .el-carousel__indicator.is-active .el-carousel__button {
    background: #CF830C !important;
    width: 50px;
    height: 13px;
    border-radius: 6px;
  }

  .el-carousel__indicator--horizontal {
    padding: 0 14px !important;
  }

  .el-carousel__button {
    width: 50px;
    height: 13px;
    background: #fff !important;
    border-radius: 6px;
  }
}
@media screen and (max-width: 768px) {
  .units {
    .el-carousel {
      .el-carousel__indicators {
        bottom: 5px;
      }
    }

    .el-carousel .el-carousel__indicator.is-active .el-carousel__button {
      width: 30px;
      height: 6px;
    }

    .el-carousel__indicator--horizontal {
      padding: 0 8px !important;
    }

    .el-carousel__button {
      width: 30px;
      height: 6px;
    }
  }
}

@media screen and (max-width: 480px) {
  .units {
    .el-carousel .el-carousel__indicator.is-active .el-carousel__button {
      width: 24px;
      height: 4px;
    }

    .el-carousel__button {
      width: 24px;
      height: 4px;
    }

    .el-carousel__indicator--horizontal {
      padding: 0 5px !important;
    }
  }
}
</style>



